// ItemIssuePage.jsx
import {Navbar,Footer,Sidebar} from '../medicalcomponents';
import React, { useEffect, useState, useRef  } from "react";
import axios from "axios";
import configData from "../config.json";
import { format } from 'date-fns';
import { useReactToPrint } from "react-to-print";
import Select from "react-select";
import * as Icon from 'react-bootstrap-icons';

const ItemIssue=()=> {

  if (localStorage.getItem('branchID') === null) {
    window.location.replace('/');
  }

    const componentRef = useRef(null);

  const [itemList, setItemList] = useState([]); // {id, name, stockQty}
  const [filterItemList, setFilterItemList] = useState([]);
  const [itemId, setItemId] = useState("");
  const [qty, setQty] = useState("");
  const [gridData, setGridData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [itemSearch,setItemSearch]=useState("");
  const [consumer,setConsumer]=useState("");
  const [useOf,setUseOf]=useState("G");
  

  const [empData,setEmpData]=useState([]);
  const [filterEmp, setFilterEmp] = useState([]);
  const [empSearch,setEmpSearch]=useState();
  const [empID, setEmpId] = useState("");
  const [medecineDose, setMedecineDose] = useState("");
  const [medecineDays, setMedecineDays] = useState("");

  const [voucher, setVoucher] = useState([]);
  

  useEffect(() => {
    const getAssetData = async () => {
          const response=await axios.get(configData.SERVER_URL+`/itemData/${localStorage.getItem('branchID')}`);
          setItemList(response.data);
          setFilterItemList(response.data);

          const res=await axios.get(configData.SERVER_URL+`/empData/${localStorage.getItem('branchID')}`);
          setEmpData(res.data);
          setFilterEmp(res.data);

    };
    getAssetData();
  }, []);

  const resetInputs = () => {
    setItemId("");
    setQty("");
    // setRemarks("");
  };

  const handleAddToGrid = () => {
    if (!itemId) return alert("Select an item.");
    if (!qty || Number(qty) <= 0) return alert("Enter valid quantity.");

    const selected = itemList.find((i) => String(i.id) === String(itemId));
    if (!selected) return alert("Invalid item selected.");

    // Add row (simple push, duplicates allowed in this simple version)
    setGridData((prev) => [
      ...prev,
      {
        itemId: selected.id,
        itemName: selected.itemName,
        qty: Number(qty),
        medecineDose: medecineDose,
        medecineDays:medecineDays,
      },
    ]);

    resetInputs();
  };

  const handleDeleteRow = (index) => {
    setGridData((prev) => prev.filter((_, i) => i !== index));
  };

  const handleEditRow = (index) => {
    // simple inline edit flow: load row into inputs and remove row
    const row = gridData[index];
    setItemId(row.itemId);
    setQty(row.qty);
    // setRemarks(row.remarks);
    setGridData((prev) => prev.filter((_, i) => i !== index));
  };

  const handleSubmitFinal = async () => {
    if (gridData.length === 0) return alert("No items to submit.");

    const payload = {
      issueDate: format(new Date(),'yyyy-MM-dd'),
      items: gridData,
      empID:empID,
      branchID:localStorage.getItem('branchID'),
      consumer:consumer,
      useOf:useOf,
    };

    try {
        setLoading(true);
        let res=await axios.post(configData.SERVER_URL+`/voucherEntry`,payload);
        if(res.status===200){
            alert(res.data.message);
            setGridData([]);
            setVoucher(res.data.voucher.data);
        }
    } catch (err) {
      console.error(err);
      alert("Save failed: " + (err.message || err));
    } finally {
      setLoading(false);
    }
  };

  const filterItem=(e)=>{

    const value = e.target.value.toLowerCase();   
    setItemSearch(value);

    const updatedList = itemList.filter(items =>
        items.itemCode?.toLowerCase().includes(value) ||
        items.itemName?.toLowerCase().includes(value) ||
        items.groupName?.toLowerCase().includes(value)
    );
    setFilterItemList(updatedList);
    }

    const filterEmployee=(e)=>{
        const value = e.target.value.toLowerCase(); 
        setEmpSearch(value);
        const updatedList = empData.filter(emp =>
        emp.empCode?.toLowerCase().includes(value) ||
        emp.empName?.toLowerCase().includes(value) 
        );
        setFilterEmp(updatedList);
    }

    const printDiv = (printDiv) => {
        const printElement = document.getElementById(printDiv);

        if (!printElement) {
            console.error("Print div not found");
            return;
        }

        const printWindow = window.open("", "_blank", "width=900,height=650");

        printWindow.document.write(`
            <html>
                <head>
                <title>Print</title>
                <!-- Bootstrap CSS (optional) -->
                <link rel="stylesheet"  href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css"/>
                <style>
                    body{ padding:20px; font-family: Arial, sans-serif;}
                    @media print { body{ margin:0; }}
                </style>
                </head>
                <body>
                    ${printElement.innerHTML}
                </body>
            </html>
        `);
        printWindow.document.close();
        printWindow.focus();
        setTimeout(() => {
            printWindow.print();
            printWindow.close();
        }, 500);
    };

  return (
  <>
    <div className="container-fluid">

      {/* ================= HEADER CARD ================= */}
      <div className="card shadow-sm mb-3">
        <div className="card-header d-flex justify-content-between align-items-center"
                style={{
                background: "linear-gradient(135deg, #0d6efd, #0dcaf0)",
                color: "#fff",
                padding: "18px 25px",
                border: "none",
                }} >
                <div>
                    <h3 className="mb-0 fw-bold">Item Issue (Medical System)</h3>
                </div>
        </div>

        <div className="card-body">
          <div className="row g-3">

            {/* Employee */}
            <div className="col-md-6">
              <label className="form-label">Issue To</label>
              <Select
                options={filterEmp.map(d => ({
                  value: d.id,
                  label: `${d.empCode} : ${d.empName}`
                }))}
                isSearchable
                placeholder="Select Employee..."
                onChange={(opt) => setEmpId(opt?.value || null)}
              />
            </div>

            {/* Use Of */}
            <div className="col-md-3">
              <label className="form-label">Use Of</label>
              <select className="form-control" value={useOf} onChange={(e) => setUseOf(e.target.value)}>
                <option value="G">General</option>
                <option value="E">Emergency</option>
              </select>
            </div>

            {/* Consumer */}
            <div className="col-md-3">
              <label className="form-label">Consumer</label>
              <select className="form-control" value={consumer} onChange={(e) => setConsumer(e.target.value)}>
                <option value="Self">Self</option>
                <option value="Family">Family</option>
              </select>
            </div>

          </div>
        </div>
      </div>

      {/* ================= ITEM ENTRY ================= */}
      <div className="card shadow-sm mb-3">
        <div className="card-body">

          <div className="row g-3 align-items-end">

            {/* Item */}
            <div className="col-md-5">
              <label>Item</label>
              <Select
                options={filterItemList.map(it => ({
                  value: it.id,
                  label: `${it.itemCode} : ${it.itemName} : ${it.currentStock}`
                }))}
                isSearchable
                placeholder="Select Item..."
                onChange={(opt) => setItemId(opt?.value || null)}
              />
            </div>

            {/* Dose */}
            <div className="col-md-3">
              <label>Dose</label>
              <input
                className="form-control"
                value={medecineDose}
                onChange={(e) => setMedecineDose(e.target.value)}
              />
            </div>

            {/* Days */}
            <div className="col-md-2">
              <label>Days</label>
              <input
                type="number"
                className="form-control"
                value={medecineDays}
                onChange={(e) => setMedecineDays(e.target.value)}
              />
            </div>

            {/* Qty + Button */}
            <div className="col-md-2 d-flex gap-2">
              <div style={{ flex: 1 }}>
                <label>Qty</label>
                <input
                  type="number"
                  className="form-control"
                  value={qty}
                  onChange={(e) => setQty(e.target.value)}
                />
              </div>

              <button
                className="btn btn-success mt-auto"
                onClick={handleAddToGrid}
              >
                + Add
              </button>
            </div>

          </div>
        </div>
      </div>

      {/* ================= GRID TABLE ================= */}
      <div className="card shadow-sm mb-3">
        <div className="card-body table-responsive">

          <table className="table table-bordered table-hover align-middle text-center">

            <thead className="table-dark">
              <tr>
                <th width="50px">#</th>
                <th>Item</th>
                <th>Dose</th>
                <th>Qty</th>
                <th style={{ width: 140 }}>Action</th>
              </tr>
            </thead>

            <tbody>
              {gridData.length === 0 ? (
                <tr>
                  <td colSpan="5" className="text-muted">
                    No items added
                  </td>
                </tr>
              ) : (
                gridData.map((r, i) => (
                  <tr key={i}>
                    <td>{i + 1}</td>
                    <td className="text-start">{r.itemName}</td>
                    <td>{r.medecineDose} ({r.medecineDays} days)</td>
                    <td>{r.qty}</td>
                    <td>
                      <button
                        className="btn btn-sm btn-primary me-1"
                        onClick={() => handleEditRow(i)}
                      >
                        Edit
                      </button>
                      <button
                        className="btn btn-sm btn-danger"
                        onClick={() => handleDeleteRow(i)}
                      >
                        Del
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>

          </table>

          {/* Buttons */}
          <div className="d-flex justify-content-end gap-2 mt-3">
            <button className="btn btn-secondary" onClick={() => setGridData([])}>
              Clear
            </button>

            <button
              className="btn btn-primary"
              onClick={handleSubmitFinal}
              disabled={loading}
            >
              {loading ? "Saving..." : "Submit"}
            </button>
          </div>

        </div>
      </div>

      {/* ================= PRINT AREA ================= */}
      {voucher && voucher.length > 0 && (
        <div className="card shadow-sm" id="print-voucher">

          <div className="card-header bg-success text-white d-flex justify-content-between">
            <h5 className="mb-0">Prescription Details</h5>
            {/* <button className="btn btn-light btn-sm" onClick={printDiv("print-voucher")}>
              Print
            </button> */}
            <button
                                  type="button"
                                  className="btn btn-light"
                                  onClick={() => printDiv("print-voucher")}
                                  style={{
                                    borderRadius: "50px",
                                    padding: "10px 18px",
                                    fontWeight: "600",
                                  }}
                                >
                                  <Icon.Printer className="me-2" />
                                  Print
                                </button>
          </div>

          <div className="card-body">

            <p><b>Invoice No:</b> {voucher[0].issueNo}</p>
            <p><b>Date:</b> {format(new Date(voucher[0].issueDate), 'dd-MM-yyyy')}</p>
            <p><b>Employee:</b> {voucher[0].empName} ({voucher[0].empCode})</p>
            <p><b>Dept:</b> {voucher[0].deptName}</p>
            <p><b>Consumer:</b> {voucher[0].consumer}</p>

          </div>

          <table className="table table-bordered text-center">
            <thead className="table-info">
              <tr>
                <th>#</th>
                <th>Item</th>
                <th>Dose</th>
                <th>Days</th>
                <th>Qty</th>
              </tr>
            </thead>

            <tbody>
              {voucher.map((r, i) => (
                <tr key={i}>
                  <td>{i + 1}</td>
                  <td className="text-start">{r.itemName}</td>
                  <td>{r.medecineDose}</td>
                  <td>{r.medecineDays}</td>
                  <td>{r.issueQty}</td>
                </tr>
              ))}
            </tbody>
          </table>

        </div>
      )}

    </div>
  </>
);
}


export default ItemIssue;